angular.module('jv.common.parse-querystring.service', [])
.factory('parseQuerystring', function() {
    return function parseQueryString(uri, processValue) {
        var queryString = {};
        processValue = processValue || function(val) { return val; };
        uri.replace(/([^?=&]+)(=([^&]*))?/g, function($0, $1, $2, $3) {
            queryString[$1] = processValue($3);
        });
        return queryString;
    }
});